'use strict';



const path = require('path');
const retina = require('is-retina');



module.exports = function applyRetinafy(selector) {

	if(!retina()) {
		return;
	}

	const img = document.querySelectorAll(selector);
	[].forEach.call(img, retinafy);

};



function retinafy(img) {

	const src = img.src || img.style.backgroundImage.slice(4, -1);
	const extension = path.extname(src);
	const [ pathName ] = src.split(extension);
	const retinaSrc = `${pathName}@2x${extension}`;

	return img.dataset.retina === 'background' ?
		img.style.backgroundImage = `url(${retinaSrc})` :
		img.setAttribute('src', retinaSrc);

}
